import { render, staticRenderFns } from "./CadAnexo.vue?vue&type=template&id=4a873563"
import script from "./CadAnexo.vue?vue&type=script&lang=js"
export * from "./CadAnexo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports